import React from 'react';
import {Link} from 'react-router-dom';
import {HashLink} from 'react-router-hash-link';
import webUtils from '../../utils/webUtils';
import _startsWith from 'lodash/startsWith';
import {useTranslation} from 'react-i18next';

export default function PFLink({to, hash, isBusiness, linkRef, children, isNewTab = false, rel, ...props}) {
  const {i18n} = useTranslation();
  if (!to) {
    return (
      <Link to="" ref={linkRef} {...props}>
        {children}
      </Link>
    );
  }
  if (_startsWith(to, 'http')) {
    return (
      <a href={to} ref={linkRef} {...props} rel={rel ? rel : 'noopener noreferrer'} target={isNewTab ? '_blank' : '_self'}>
        {children}
      </a>
    );
  }
  return (
    <Link
      target={isNewTab ? '_blank' : '_self'}
      rel={rel && rel}
      // to={`${langParam}${to}`}
      to={to}
      ref={linkRef}
      {...props}
    >
      {children}
    </Link>
  );
}
